module.exports = __webpack_public_path__ + "media/SOC/box-946ab363.svg";